// extracted by mini-css-extract-plugin
export default {"container":"Anuncie_container__Muflv","formulario":"Anuncie_formulario__VSTNO"};